import repository from '@/api/modules/Logistics/Dispatches';
import masterdata from '@/api/modules/MasterData/index';
import dropdown from '@/api/Main/DropDowns/index';
import { makeAction } from '@/store/utils/createCrudModule';

export default {
  state: {
    all_dispatches: [],
    vehicles: [],
    post_get_customers: [],
    get_packing_list: [],
    get_vehicle_cbm: [],
    get_item_cbm: [],
    store_dispatches: [],
    get_dispatches: [],
    get_dispatch_edit_info: [],
    update_dispatch_info: [],
    dispatch_date_from: '',
    dispatch_date_to: '',
    vehicle_id: '',
  },
  getters: {
    GET_ALL_DISPATCHES:    state => state.all_dispatches,
    GET_VEHICLES:          state => state.vehicles,
    POST_GET_CUSTOMERS:    state => state.post_get_customers,
    GET_PACKING_LISTS:     state => state.get_packing_list,
    GET_VEHICLE_CBM:       state => state.get_vehicle_cbm,
    GET_ITEM_CBM:          state => state.get_item_cbm,
    GET_DISPATCHES:        state => state.get_dispatches,
    GET_DISPATCH_EDIT_INFO: state => state.get_dispatch_edit_info,
  },
  actions: {
    getAllDispatches:    makeAction(repository, 'getalldispatches', 'ALL_DISPATCHES'),
    getVehicle:         makeAction(dropdown, 'vehicles', 'VEHICLES'),
    getPostCustomers:   makeAction(masterdata, 'postgetcustomers', 'POST_CUSTOMERS'),
    getPackingList:     makeAction(masterdata, 'getpackinglist', 'PACKING_LISTS'),
    getVehicleCBM:      makeAction(repository, 'getvehiclecbm', 'VEHICLE_CBM'),
    getItemCBM:         makeAction(repository, 'getitemcbm', 'ITEM_CBM'),
    storeDispatches:    makeAction(repository, 'storedispatches', 'STORE_DISPATCHES'),
    getDispatch:        makeAction(repository, 'getdispatch', 'DISPATCH'),
    getDispatchEditInfo: makeAction(repository, 'getdispatcheditinfo', 'DISPATCH_EDIT_INFO'),
    updateDispatchInfo:  makeAction(repository, 'updatedispatchinfo', 'UPDATE_DISPATCH_INFO'),
    destroyDispatch:     makeAction(repository, 'destroydispatch'),
    updateDispatchStatus: makeAction(repository, 'updatedispatchstatus'),
    dispatchGet:         makeAction(repository, 'dispatchGet'),
    dispatchPost:        makeAction(repository, 'dispatchPost'),

    exportdispatch({ commit, state }) {
      const payload = {
        date_from: state.dispatch_date_from,
        date_to: state.dispatch_date_to,
        vehicle_id: state.vehicle_id,
      };
      return new Promise((resolve, reject) => {
        repository.exportdispatch(payload).then(response => {
          if (response.status === 200) resolve(response);
        }).catch(reject);
      });
    },
  },
  mutations: {
    ALL_DISPATCHES:       (state, data) => { state.all_dispatches         = data; },
    VEHICLES:             (state, data) => { state.vehicles               = data; },
    POST_CUSTOMERS:       (state, data) => { state.post_get_customers     = data; },
    PACKING_LISTS:        (state, data) => { state.get_packing_list       = data; },
    VEHICLE_CBM:          (state, data) => { state.get_vehicle_cbm        = data; },
    ITEM_CBM:             (state, data) => { state.get_item_cbm           = data; },
    STORE_DISPATCHES:     (state, data) => { state.store_dispatches       = data; },
    DISPATCH:             (state, data) => { state.get_dispatches         = data; },
    DISPATCH_EDIT_INFO:   (state, data) => { state.get_dispatch_edit_info = data; },
    UPDATE_DISPATCH_INFO: (state, data) => { state.update_dispatch_info   = data; },
    DISPATCH_DATE_FROM:   (state, data) => { state.dispatch_date_from     = data; },
    DISPATCH_DATE_TO:     (state, data) => { state.dispatch_date_to       = data; },
    DISPATCH_VEHICLES_ID: (state, data) => { state.vehicle_id             = data; },
  },
};
